"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAError = exports.ChannelAccountsErrorCodes = void 0;
const error_1 = require("../../stellar-plus/error");
var ChannelAccountsErrorCodes;
(function (ChannelAccountsErrorCodes) {
    // CHA0 General
    ChannelAccountsErrorCodes["CHA001"] = "CHA001";
})(ChannelAccountsErrorCodes || (exports.ChannelAccountsErrorCodes = ChannelAccountsErrorCodes = {}));
const invalidNumberOfChannelsToCreate = (min, max) => {
    return new error_1.StellarPlusError({
        code: ChannelAccountsErrorCodes.CHA001,
        message: 'Invalid number of channels to create!',
        source: 'ChannelAccounts',
        details: `Invalid number of channels to create! Must be between ${min} and ${max} for each invocation!`,
    });
};
exports.CHAError = {
    invalidNumberOfChannelsToCreate,
};
